export interface ZoneJson {
	id: string;
	name: string;
	maxZones: number | null;
	adjacentZoneIds: string[];
	adjacentZoneNames: string[];
}

export interface Zone {
	id: string;
	name: string;
	adjacentZoneIds: string[];
}

const mapZone = (json: ZoneJson): Zone => ({
	id: json.id,
	name: json.name,
	adjacentZoneIds: json.adjacentZoneIds,
});

export const mapZones = (json: ZoneJson[]): Zone[] => json.map(mapZone);

export const getValidZone = (): ZoneJson => ({
	id: "RUT:TariffZone:227",
	name: "1",
	maxZones: null,
	adjacentZoneIds: [
		"RUT:TariffZone:228",
		"RUT:TariffZone:226",
		"RUT:TariffZone:231",
	],
	adjacentZoneNames: ["2S", "2V", "2Ø"],
});
